module.exports = __webpack_public_path__ + "img/exp(ario).9120c83e.svg";